import { createReducerContext } from '../../../../utils/create-reducer-context';
import { BannerState, BannerReducer, ACTION_TYPES } from './banner-reducer';

const initialState: BannerState = {
    banners: [],
    loading: false,
    drawer: { open: false },
};

const { Provider: BannerProvider, useStateContext: useBannerState, useDispatchContext: useBannerDispatch } = createReducerContext('Banner', BannerReducer, initialState);

export { BannerProvider, useBannerState, useBannerDispatch, ACTION_TYPES };
